module.exports = __webpack_public_path__ + "img/cover-promotion-bg.1fa27ea5.jpg";